import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import instanceAPI from '../config/axiosconfig';

export const getFaqs = createAsyncThunk(
  'faq/getFaq',
  async () => {
    const faq = await instanceAPI.get('/get-faqs')
      .then((resp) => resp.data.faqs);
    return faq;
  },
);

const faqSlice = createSlice({
  name: 'faq',
  initialState: {
    faq: [],
    status: null,
  },
  extraReducers: {
    [getFaqs.pending]: (state) => {
      state.status = 'loading';
    },
    [getFaqs.fulfilled]: (state, action) => {
      state.status = 'success';
      state.faq = action.payload;
    },
    [getFaqs.rejected]: (state) => {
      state.status = 'failed';
    },
  },
});

export default faqSlice.reducer;
